module.exports = __webpack_public_path__ + "img/business-location.74240168.png";